import { render, staticRenderFns } from "./buscador-personas-morales.vue?vue&type=template&id=28d05d14&scoped=true&"
import script from "./buscador-personas-morales.component.ts?vue&type=script&lang=ts&"
export * from "./buscador-personas-morales.component.ts?vue&type=script&lang=ts&"
import style0 from "./buscador-personas-morales.vue?vue&type=style&index=0&id=28d05d14&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d05d14",
  null
  
)

export default component.exports